import firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth'

// firebase init goes here
const config = {
    apiKey: "AIzaSyAJjoK9nWMIruz4yaeUkvzFpPyC351uXFU",
    authDomain: "code-clans-for-dev-dont-delete.firebaseapp.com",
    databaseURL: "https://code-clans-for-dev-dont-delete.firebaseio.com",
    projectId: "code-clans-for-dev-dont-delete",
    storageBucket: "code-clans-for-dev-dont-delete.appspot.com",
    messagingSenderId: "339414857886",
    appId: "1:339414857886:web:c78c54b202167e924ee38f"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

const ordersCollection = db.collection('orders')

export {
    db,
    auth,
    currentUser,
    ordersCollection,
}
